var divider_viewer_rtlignore_default = {
  "divider-container": "ScGPa",
  "divider-container--double": "amZtm",
  "divider": "RcfLz",
  "divider--single": "jj-zz",
  "divider--double": "W9aud",
  "divider--dashed": "sPSFU",
  "divider--dotted": "_76-Dg",
  "divider--small": "Ew11V",
  "divider--small--mobile": "_6TPb9",
  "divider--medium": "tDEhx",
  "divider--large--mobile": "OofCe",
  "divider--medium--mobile": "ykHs7",
  "divider--large": "LLMjD",
  "divider--left": "p646J",
  "divider--center": "JgWqO",
  "divider--right": "kviRL",
  "divider--fill-parent": "_73Q-5",
  "svgFixerContainer": "wwfBl",
  "emptyChar": "J3Hn5"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
